/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_Real_TitleInputs */



/**
* | output |
* | --- |
* | "Extra: for your real conversations too" |
*
* @param {Onboarding_Pilot_How_Real_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_real_title = /** @type {((inputs?: Onboarding_Pilot_How_Real_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_Real_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Extra: ook voor je echte gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("En plus : aussi pour vos vraies conversations")
	return /** @type {LocalizedString} */ ("Extra: for your real conversations too")
});